<template>
    <div :class="'help-notice ' + noticeType">
        <div class="flex">
            <div class="shrink-0 help-notice-icon">
                <i class="fal fa-info-circle"></i>
            </div>
            <div class="help-notice-message">
                {{ noticeText }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelpNotice",
    props: {
        noticeType: {
            type: String,
            required: true,
        },
        noticeText: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
